/* Japan Card Collect — sections « à la une » (carrousels : promos JP + cartes populaires) */
(function () {
  "use strict";
  const I18N = window.I18N || { fr: {}, en: {} };
  const lang = () => ((document.documentElement.lang || "fr") === "en" ? "en" : "fr");
  const t = (k) => (I18N[lang()] && I18N[lang()][k]) || (I18N.fr && I18N.fr[k]) || "";
  const fmt = (p) => (lang() === "en" ? "€" + p.toFixed(2) : p.toFixed(2).replace(".", ",") + " €");
  const esc = (s) => String(s == null ? "" : s).replace(/"/g, "&quot;");
  const nameOf = (c) => (lang() === "en" ? c.en : c.fr) || c.fr;
  /* img : nom d'asset thème (cards-x.webp) → base CDN ; URL absolue (image produit Shopify) → telle quelle */
  const imgSrc = (u) => (/^(https?:)?\/\//.test(u) || String(u).charAt(0) === "/") ? u : window.JCC.base + u;
  /* c.img = ce qu'on affiche, c.photo = repli si l'image casse. La SOURCE dépend de la surface :
     rails (arrivages, populaires, AR) → vraie photo Vinted ; sections designées (marquee promo)
     → scan détouré. C'est le snippet jcc-rail-data.liquid qui tranche, pas ce fichier. */
  const railImg = (c, cls, name) => '<img class="' + cls + '" src="' + imgSrc(c.img) + '" alt="' + esc(name) +
    '" loading="lazy"' + (c.photo ? ' onerror="this.onerror=null;this.src=\'' + c.photo + '\'"' : '') + ' />';

  let promos = null, promosAll = null, hot = null, reviews = null, arrivals = null, arsel = null;

  /* Pied de carte : prix + ajout panier direct (règle boutique : achat depuis tous les carrousels) */
  function cardFoot(c) {
    const out = c.stock === 0;
    return '<div class="ccard__foot"><span class="price">' + fmt(c.price) + '</span>' +
      '<button class="btn btn--dark ccard__add" type="button"' + (out ? " disabled" : "") + '>' + t("set_add") + '</button></div>';
  }
  function promoCard(c) {
    const name = nameOf(c);
    const href = c.n ? "/products/" + c.code.toLowerCase() + "-" + c.n : "/collections/promos";
    return '<article class="ccard ccard--go" data-href="' + href + '" aria-label="' + esc(name) + '">' +
      '<div class="ccard__media"><img class="promo-mark" src="' + window.JCC.base + 'promo-badge.svg" alt="Promo" />' +
      '<img class="ccard__wm" src="' + window.JCC.base + 'logo.png" alt="Japan Card Collect" />' +
      '<div class="ccard__cardwrap">' + railImg(c, 'ccard__scan', name) + '</div></div>' +
      '<div class="ccard__info"><span class="ccard__name">' + esc(name) +
        ' <span class="ccard__name-ref">· ' + esc(c.num || c.code) + '</span></span>' +
      '<span class="ccard__series">' + t("fc_promo") + '</span>' + cardFoot(c) + '</div></article>';
  }
  function hotCard(c) {
    const name = nameOf(c);
    const href = c.n ? "/products/" + c.code.toLowerCase() + "-" + c.n : "/collections/" + c.code.toLowerCase();
    return '<article class="ccard ccard--go" data-href="' + href + '" aria-label="' + esc(name) + '">' +
      '<div class="ccard__media"><img class="ccard__sym" src="' + window.JCC.base + 'sets-symbols-' + c.code.toLowerCase() + '.png" alt="' + esc(c.code) + '" onerror="this.remove()" />' +
      '<img class="ccard__wm" src="' + window.JCC.base + 'logo.png" alt="Japan Card Collect" />' +
      '<div class="ccard__cardwrap">' + railImg(c, 'ccard__scan', name) + '</div></div>' +
      '<div class="ccard__info"><span class="ccard__name">' + esc(name) +
        ' <span class="ccard__name-ref">· ' + esc(c.num) + '</span></span>' +
      '<span class="ccard__series">' + esc(c.setEn || c.rar || "") + '</span>' + cardFoot(c) + '</div></article>';
  }

  /* Carte d'avis Vinted (marquee) — avatar Pokémon + étoiles « rareté TCG » + achat vérifié */
  const RSTAR = '<svg class="rstar rstar--sm" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M12 1.8l3.1 6.3 6.9.9-5 4.8 1.2 6.9-6.2-3.3-6.2 3.3 1.2-6.9-5-4.8 6.9-.9z" ' +
    'fill="url(#gstar)" stroke="#15151e" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  function revCard(c) {
    const L = lang();
    const txt = (L === "en" ? c.en : c.fr) || c.fr;
    return '<figure class="rev-card">' +
      '<div class="rev-card__stars" role="img" aria-label="5/5">' + RSTAR.repeat(5) + "</div>" +
      '<blockquote class="rev-card__quote">' + esc(txt) + "</blockquote>" +
      '<span class="rev-card__buy">' + esc(c.buy) + "</span>" +
      '<figcaption class="rev-card__who">' +
        '<img class="rev-card__avatar" src="' + window.JCC.base + 'avatars-' + c.av + '.webp" alt="" loading="lazy" />' +
        "<span><b>" + esc(c.name) + '</b><i>' + t("verified") + "</i></span>" +
      "</figcaption></figure>";
  }

  /* Item compact du marquee promo (scan + mark officiel + légende au survol) */
  function pmItem(c) {
    const name = nameOf(c);
    const href = c.n ? "/products/" + c.code.toLowerCase() + "-" + c.n : "/collections/promos";
    return '<a class="pm-item" href="' + href + '" aria-label="' + esc(name) + ' · ' + esc(c.num) + '">' +
      railImg(c, 'pm-item__scan', name) +
      '<img class="pm-item__mark" src="' + window.JCC.base + 'promo-badge.svg" alt="" aria-hidden="true" />' +
      '<span class="pm-item__cap">' + esc(name) + " · " + fmt(c.price) + "</span></a>";
  }

  function render() {
    const ps = document.getElementById("promoStrip");
    if (ps && promos) ps.innerHTML = promos.map(promoCard).join("");
    /* Marquee accueil : contenu dupliqué ×2 → boucle translateX(-50%) sans couture */
    const mq = document.getElementById("promoMarqueeTrack");
    if (mq && promos) {
      mq.innerHTML = promos.concat(promos).map(pmItem).join("");
      mq.style.setProperty("--mq-dur", Math.round(promos.length * 3.4) + "s");
    }
    const pg = document.getElementById("promoGrid");
    if (pg && promosAll) {
      pg.innerHTML = promosAll.map(promoCard).join("");
      const cnt = document.getElementById("promoCount");
      if (cnt) cnt.textContent = promosAll.length;
    }
    const hs = document.getElementById("hotStrip");
    if (hs && hot) hs.innerHTML = hot.map(hotCard).join("");
    const avs = document.getElementById("arrivalsStrip");
    if (avs && arrivals) avs.innerHTML = arrivals.map(hotCard).join("");
    const ars = document.getElementById("arStrip");
    if (ars && arsel) ars.innerHTML = arsel.map(hotCard).join("");
    /* Marquee avis : dupliqué ×2 pour la boucle sans couture */
    const rv = document.getElementById("revMarqueeTrack");
    if (rv && reviews) {
      rv.innerHTML = reviews.concat(reviews).map(revCard).join("");
      rv.style.setProperty("--mq-dur", Math.round(reviews.length * 5) + "s");
    }
  }

  /* Clic carrousels : bouton = ajout panier direct, reste de la carte = page produit */
  ["promoStrip", "promoGrid", "hotStrip", "arrivalsStrip", "arStrip"].forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.addEventListener("click", (e) => {
      const btn = e.target.closest(".ccard__add");
      if (btn) {
        if (btn.disabled) return;
        const cnt = document.querySelector(".cart__count");
        if (cnt) cnt.textContent = (parseInt(cnt.textContent, 10) || 0) + 1;
        btn.classList.add("is-added");
        btn.textContent = "✓";
        setTimeout(() => { btn.classList.remove("is-added"); btn.textContent = t("set_add"); }, 1100);
        return;
      }
      const art = e.target.closest(".ccard");
      if (art && art.dataset.href) location.href = art.dataset.href;
    });
  });

  // flèches de défilement des rails
  document.querySelectorAll(".rail-arrow").forEach((b) => {
    b.addEventListener("click", () => {
      const rail = document.getElementById(b.getAttribute("data-rail"));
      if (!rail) return;
      const dir = b.classList.contains("rail-arrow--prev") ? -1 : 1;
      rail.scrollBy({ left: dir * Math.round(rail.clientWidth * 0.85), behavior: "smooth" });
    });
  });

  const jobs = [];
  /* Rails « populaire / arrivages / promos » alimentés en DIRECT par des collections Shopify
     (script #...Data émis côté serveur, images produit) ; repli sur l'ancien JSON de thème si vide. */
  const readInline = (id) => {
    const el = document.getElementById(id);
    if (!el) return null;
    try { const a = JSON.parse(el.textContent); return a.length ? a : null; } catch (e) { return null; }
  };
  if (document.getElementById("promoStrip") || document.getElementById("promoMarqueeTrack")) {
    promos = readInline("promosData");
    if (!promos) jobs.push(fetch(window.JCC.data.promos).then((r) => r.json()).then((d) => { promos = d.cards; }).catch(() => {}));
  }
  if (document.getElementById("promoGrid")) jobs.push(fetch(window.JCC.data.promosAll).then((r) => r.json()).then((d) => { promosAll = d.cards; }).catch(() => {}));
  if (document.getElementById("hotStrip")) {
    hot = readInline("hotData");
    if (!hot) jobs.push(fetch(window.JCC.data.hot).then((r) => r.json()).then((d) => { hot = d.cards; }).catch(() => {}));
  }
  if (document.getElementById("arrivalsStrip")) {
    arrivals = readInline("arrivalsData");
    if (!arrivals) jobs.push(fetch(window.JCC.data.arrivals).then((r) => r.json()).then((d) => { arrivals = d.cards; }).catch(() => {}));
  }
  if (document.getElementById("arStrip")) {
    /* sélection AR : données EN DIRECT depuis la collection Shopify (stock + vraies photos) ;
       repli sur l'ancien JSON de thème, qui lui est figé. */
    arsel = readInline("arData");
    if (!arsel) jobs.push(fetch(window.JCC.data.ar).then((r) => r.json()).then((d) => { arsel = d.cards; }).catch(() => {}));
  }
  if (document.getElementById("revMarqueeTrack")) jobs.push(fetch(window.JCC.data.reviews).then((r) => r.json()).then((d) => { reviews = d.cards; }).catch(() => {}));
  Promise.all(jobs).then(render);

  new MutationObserver(render).observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });
})();
